var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 1rem 0;\n  text-align: center;\n'], ['\n  margin: 1rem 0;\n  text-align: center;\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';
import { Link } from 'react-router-dom';
import InputWrapper from '../wrappers/InputWrapper';
import withFormValidations from 'react-validator';
import { PasswordStrength } from '../PasswordStrength';
import styled from 'styled-components';
import Button from '../Button';
import { Form, Group } from '../forms/StyledComponents';
import { AlternateCTA } from './StyledComponents';

var SignUp = Button.extend(_templateObject);

var LogIn = styled.div(_templateObject2);

var Signup = function (_React$Component) {
  _inherits(Signup, _React$Component);

  function Signup() {
    var _temp, _this, _ret;

    _classCallCheck(this, Signup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      errors: null
    }, _this.signup = function (e) {
      e.preventDefault();

      var _this$props = _this.props,
          emailCallback = _this$props.emailCallback,
          field = _this$props.field,
          inputs = _this$props.inputs,
          signupCallback = _this$props.signupCallback;


      if (_this.props.valid()) {
        emailCallback(field('email').validations.val).then(function (res) {
          return res.data.length > 0 ? Promise.reject(null) : Promise.resolve(null);
        }).then(function (res) {
          return signupCallback(inputs);
        }).then(function (res) {
          return _this.props.goBack && _this.props.goBack();
        }).then(function (res) {
          return _this.props.actionCallback();
        }).catch(function (err) {
          if (isArray(err)) err = err[0];

          return _this.setState({
            errors: {
              title: err && err.title || 'Invalid Email',
              detail: err && err.detail || 'There is already an account with that email address.'
            }
          });
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Signup.prototype.componentDidMount = function componentDidMount() {
    this.emailInput.focus();
  };

  Signup.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        field = _props.field,
        onChange = _props.onChange,
        valid = _props.valid;


    return React.createElement(
      'div',
      null,
      React.createElement(
        'h1',
        null,
        'Sign Up'
      ),
      this.props.messages && this.props.messages.map(function (m) {
        return m;
      }),
      React.createElement(
        Form,
        { name: 'login' },
        React.createElement(
          'p',
          null,
          React.createElement(
            'small',
            null,
            'All fields are required.'
          )
        ),
        React.createElement(
          Group,
          null,
          React.createElement(
            'label',
            { htmlFor: 'email' },
            'Your Email'
          ),
          React.createElement(InputWrapper, {
            id: 'email',
            input: field('email'),
            onChange: onChange,
            type: 'email',
            valid: valid,
            autoComplete: 'email',
            inputRef: function inputRef(c) {
              return _this2.emailInput = c;
            }
          })
        ),
        React.createElement(
          Group,
          null,
          React.createElement(
            'label',
            { htmlFor: 'password' },
            'Password'
          ),
          React.createElement(PasswordStrength, { password: field('password').validations.val }),
          React.createElement(InputWrapper, {
            id: 'password',
            input: field('password'),
            onChange: onChange,
            type: 'password',
            valid: valid,
            autoComplete: 'off'
          })
        ),
        React.createElement(
          Group,
          null,
          React.createElement(
            'label',
            { htmlFor: 'password' },
            'Confirm Password'
          ),
          React.createElement(InputWrapper, {
            id: 'confirmPassword',
            input: field('confirmPassword'),
            onChange: onChange,
            type: 'password',
            valid: valid,
            autoComplete: 'off'
          })
        ),
        React.createElement(
          Group,
          null,
          React.createElement(
            'label',
            { htmlFor: 'password' },
            'First Name'
          ),
          React.createElement(InputWrapper, {
            id: 'first_name',
            input: field('first_name'),
            onChange: onChange,
            type: 'text',
            valid: valid,
            autoComplete: 'name'
          })
        ),
        React.createElement(
          Group,
          null,
          React.createElement(
            'label',
            { htmlFor: 'password' },
            'Home Zip Code'
          ),
          React.createElement(InputWrapper, {
            id: 'zip',
            input: field('zip'),
            onChange: onChange,
            type: 'text',
            valid: valid,
            autoComplete: 'postal-code'
          })
        ),
        this.state.errors && React.createElement(
          'div',
          { style: { color: 'red' } },
          this.state.errors.title,
          ' ',
          this.state.errors.detail
        ),
        React.createElement(
          SignUp,
          { type: 'submit', onClick: this.signup },
          'Sign Up'
        ),
        React.createElement('hr', null),
        React.createElement(
          AlternateCTA,
          null,
          'Already have an account? ',
          React.createElement(
            Link,
            { to: '/login' },
            'Log in'
          )
        )
      )
    );
  };

  return Signup;
}(React.Component);

Signup.propTypes = process.env.NODE_ENV !== "production" ? {
  goBack: PropTypes.func,
  emailCallback: PropTypes.func,
  signupCallback: PropTypes.func.isRequired,
  actionCallback: PropTypes.func.isRequired
} : {};

export default withFormValidations(Signup, [{
  label: 'email',
  rules: [{
    rule: 'email',
    message: 'Invalid email address'
  }, {
    rule: 'required',
    message: 'An email address is required'
  }]
}, {
  label: 'password',
  rules: [{
    rule: 'required',
    message: 'A password is required'
  }, {
    rule: 'max',
    args: 6,
    message: 'Password needs to be 6 or more characters'
  }, {
    rule: 'strength',
    message: 'That password is not strong enough. Please consider using numbers, upper case letters or phrases.'
  }]
}, {
  label: 'confirmPassword',
  rules: [{
    rule: 'required',
    message: 'A password is required'
  }, {
    rule: 'match',
    args: 'password',
    message: 'Password mismatch'
  }]
}, {
  label: 'first_name',
  rules: [{
    rule: 'required',
    message: 'A first name is required'
  }]
}, {
  label: 'zip',
  rules: [{
    rule: 'required',
    message: 'A home zip code is required'
  }]
}]);


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/auth/Signup.js
// module id = 798
// module chunks = 4